import type { GeneratedBusinessReport } from './api';

/** Avvia un download browser e rilascia subito l'URL temporaneo. */
export function saveDownloadedFile(file: GeneratedBusinessReport) {
  const url = URL.createObjectURL(file.blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = file.filename;
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1_000);
}
